module.exports = __webpack_public_path__ + "static/top_player-8278464075e38a29242d298d4e14bc9f.png";